import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { LogoMark } from "../components/Logo";

export default function PaymentCancel() {
  return (
    <main className="pt-[68px] min-h-[70vh] flex items-center justify-center px-4">
      <motion.div
        data-testid="payment-cancel-card"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md bg-white border border-[#E5E7EB] rounded-[2rem] p-10 text-center shadow-xl"
      >
        <LogoMark size={48} className="rounded-2xl mx-auto mb-6" />
        <h1 className="font-display font-semibold text-3xl mb-3">
          Checkout cancelled
        </h1>
        <p className="text-[#52525B] leading-relaxed">
          No charge was made. Your case is still in the queue — you can pay
          whenever you&rsquo;re ready to send.
        </p>
        <Link
          to="/"
          data-testid="cancel-home-link"
          className="mt-7 inline-flex items-center gap-2 bg-[#111827] text-[#FFFFFF] font-semibold px-8 py-3 rounded-full hover:bg-[#1F2937] transition-colors"
        >
          <ArrowLeft size={16} /> Back to home
        </Link>
      </motion.div>
    </main>
  );
}
